<template>
  <div class="station-list">
    <div class="search-con">
      <Form :model="formData" inline @keydown.native.enter.prevent="search">
        <FormItem>
          <Input v-model="formData.gas_name" placeholder="油站名称" clearable style="width: 180px"></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formData.gas_address" placeholder="油站地址" clearable style="width: 180px"></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formData.station_type" placeholder="站点类型" style="width: 130px">
            <Option value="oil_station">柴油站点</Option>
            <Option value="lng_station">LNG气站</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" :loading="loading" @click="search">搜索</Button>
          <Button @click="reset" style="margin-left: 6px">重置</Button>
        </FormItem>
      </Form>
    </div>

    <Table border :columns="columns" :data="pageList" :height="tableHeight" :loading="loading"></Table>

    <div class="page">
      <Page show-sizer show-elevator show-total
            :total="totalCount"
            :current="currentPage"
            :page-size="pageSize"
            :page-size-opts="[20, 50, 100]"
            @on-change="changePage"
            @on-page-size-change="changePageSize"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "agentStationList",
    data() {
      return {
        formData: {
          gas_name: '',
          gas_address: '',
          station_type: 'oil_station',
        },
        loading: false,
        list: [],
        currentPage: 1,
        pageSize: 20,
        tableHeight: 400,
        columns: [
          { title: '序号', width: 70, align: 'center', render: (h, params) => h('span', (this.currentPage - 1) * this.pageSize + params.index + 1) },
          { title: '站点ID', key: 'station_id', width: 100, align: 'center' },
          { title: '油站名称', key: 'gas_name', minWidth: 200, align: 'center', tooltip: true },
          { title: '油站地址', key: 'gas_address', minWidth: 240, align: 'center', tooltip: true },
          { title: '省', key: 'province_name', width: 100, align: 'center' },
          { title: '市', key: 'city_name', width: 110, align: 'center' },
          { title: '站点类型', key: 'station_type_name', width: 100, align: 'center' },
          {
            title: '油机价', key: 'price', width: 90, align: 'center',
            render: (h, params) => h('span', params.row.price === '' || params.row.price == null ? '-' : params.row.price)
          },
          {
            title: '挂牌价', key: 'ndrc_price', width: 90, align: 'center',
            render: (h, params) => h('span', params.row.ndrc_price === '' || params.row.ndrc_price == null ? '-' : params.row.ndrc_price)
          },
          { title: '经度', key: 'longitude', width: 120, align: 'center' },
          { title: '纬度', key: 'latitude', width: 120, align: 'center' },
        ],
      }
    },
    computed: {
      //一次拉全量后本地分页：受限角色数据量小，避免后端为只读列表再加分页逻辑
      pageList() {
        let start = (this.currentPage - 1) * this.pageSize;
        return this.list.slice(start, start + this.pageSize);
      },
      totalCount() {
        return this.list.length;
      }
    },
    methods: {
      calcHeight() {
        let el = this.$el ? this.$el.querySelector('.ivu-table-wrapper') : null;
        if (!el) return;
        let height = window.innerHeight - el.getBoundingClientRect().top - 70;
        this.tableHeight = height > 300 ? height : 300;
      },
      async getLists() {
        this.loading = true;
        //scene=route_plan：后端按登录角色隔离可见站点，合伙人只返回名下车队上站的站点
        let params = Object.assign({}, this.formData, { scene: 'route_plan' });
        let res = await this.$commonFun.postProxy('admin/gas/getMapStations', params);
        this.loading = false;
        if (!res || res.code !== 200) {
          this.$Message.error((res && res.msg) || '站点列表加载失败');
          return;
        }
        this.list = (res.data && res.data.stations) ? res.data.stations : [];
      },
      search() {
        this.currentPage = 1;
        this.getLists();
      },
      reset() {
        this.formData.gas_name = '';
        this.formData.gas_address = '';
        this.formData.station_type = 'oil_station';
        this.search();
      },
      changePage(page) {
        this.currentPage = page;
      },
      changePageSize(size) {
        this.pageSize = size;
        this.currentPage = 1;
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.calcHeight();
      });
      window.addEventListener('resize', this.calcHeight);
      this.getLists();
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.calcHeight);
    }
  }
</script>

<style scoped>
  .station-list .search-con {
    padding: 10px 0 0;
  }
  .station-list .page {
    margin-top: 10px;
    text-align: right;
  }
</style>
